import { Component, ViewChild, OnInit } from '@angular/core'

import { Cookie } from 'ng2-cookies/ng2-cookies'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal'

import {
  TOUR_COOKIE_NAME,
  IntroService,
  AppStateService
} from '../shared/'
import { PATH_INTRO_DATA } from './path-intro.data'
import { TILE_INTRO_DATA } from './tile-intro.data'

interface Tour {
  title: string
  image: string
  content: string
}

@Component({
  selector: 'mp-intro',
  templateUrl: './intro.html',
  styleUrls: ['./intro.scss'],
})
export class IntroComponent implements OnInit {

  public tourSegment: Tour
  public tourPosition: number
  public tour: Tour[] = []

  @ViewChild('introModal')
  public modal: ModalComponent

  private _introDataConfig = {
    1: PATH_INTRO_DATA,
    2: TILE_INTRO_DATA
  }

  private _modalStatuses = {
    CLOSED: 'closed',
    OPENED: 'opened'
  }
  private _modalStatus: string = this._modalStatuses.CLOSED

  constructor(
    private _introService: IntroService,
    private _appStateService: AppStateService
  ) {}

  public ngOnInit() {
    this._initializeAndStartIntroExperience(this._appStateService.pathConfiguration.experienceType)
    this._appStateService.pathConfigurationChanged.subscribe((config) => {
      this._initializeAndStartIntroExperience(config.experienceType)
    })
    this.modal.onClose.subscribe(() => this._modalStatus = this._modalStatuses.CLOSED)
    this.modal.onDismiss.subscribe(() => this._modalStatus = this._modalStatuses.CLOSED)
    this._introService.openIntro.subscribe(() => this.openIntro())
  }

  public moveForward(): void {
    this.moveToPosition(this.tourPosition + 1)
  }

  public moveBack(): void {
    this.moveToPosition(this.tourPosition - 1)
  }

  public moveToPosition(position: number): void {
    this.tourPosition = Math.max(0, position % this.tour.length)
    this.tourSegment = this.tour[this.tourPosition]
  }

  public isCurrentPositionTheLast(): boolean {
    return this.tourPosition === (this.tour.length - 1)
  }

  public resetIntro() {
    this.tourPosition = 0
    this.tourSegment = this.tour[this.tourPosition]
  }

  public openIntro() {
    if (this._modalStatus === this._modalStatuses.CLOSED) {
      this.modal.open('lg')
    }
    this._modalStatus = this._modalStatuses.OPENED
  }

  private _initializeAndStartIntroExperience(experienceType: number) {
    this.tour = this._getIntroData(experienceType)
    this.resetIntro()
    this._openIfCookieIsNotPresent(experienceType)
  }

  private _openIfCookieIsNotPresent(experienceType: number): void {
    if (this._hasIntroCookie(experienceType) === false) {
      this.openIntro()
      this._setIntroCookie(experienceType)
    }
  }

  private _setIntroCookie(experienceType: number): void {
    Cookie.set(this._cookieName(experienceType), '1', 365)
  }

  private _hasIntroCookie(experienceType: number): boolean {
    const introCookie = Cookie.get(this._cookieName(experienceType))
    return !!introCookie
  }

  private _cookieName(experienceType: number) {
    return TOUR_COOKIE_NAME + '-' + experienceType
  }

  private _getIntroData(experienceType: number) {
    return this._introDataConfig[experienceType] || []
  }

}



// WEBPACK FOOTER //
// ./src/app/intro/intro.component.ts